import { Link } from "react-router-dom";
import { IonIcon } from "@/components/icons/AppIcon";
import { ASSETS, SUPPORT_EMAIL } from "@/lib/assets";
import { AppStoreBadge, GooglePlayBadge } from "@/components/StoreBadges";
import { OpenAppButton } from "@/components/AppButtons";

const LINKS = [
  { to: "/", label: "Home", testid: "footer-link-home" },
  { to: "/schermen", label: "Schermen", testid: "footer-link-screens" },
  { to: "/privacy-policy", label: "Privacybeleid", testid: "footer-link-privacy" },
  { to: "/terms", label: "Algemene voorwaarden", testid: "footer-link-terms" },
  { to: "/delete-account", label: "Account verwijderen", testid: "footer-link-delete-account" },
];

const heading = "mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#CAA362]";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-[#2C2E29] bg-[#121311]">
      <div className="mx-auto max-w-7xl px-5 pt-20 md:px-10">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <img src={ASSETS.logoSmall} alt="Waidbook" className="h-16 w-auto" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#8E9189]">
              Het digitale jachtlogboek voor trofeeën, jachtgebieden, afschotplan en nazoek.
            </p>
            <OpenAppButton testid="footer-open-waidbook-btn" className="mt-6" />
          </div>
          <div>
            <h4 className={heading}>Pagina's</h4>
            <ul className="space-y-3 text-sm text-[#B5B8B0]">
              {LINKS.map((l) => (
                <li key={l.to}>
                  <Link data-testid={l.testid} to={l.to} className="transition-colors hover:text-[#E0BE82]">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className={heading}>Contact en support</h4>
            <a
              data-testid="footer-support-email"
              href={`mailto:${SUPPORT_EMAIL}`}
              className="inline-flex items-center gap-2 text-sm text-[#B5B8B0] transition-colors hover:text-[#E0BE82]"
            >
              <IonIcon name="mail-outline" size={17} className="text-[#CAA362]" />
              {SUPPORT_EMAIL}
            </a>
            <h4 className={`${heading} mt-8`}>Download</h4>
            <div className="flex flex-wrap gap-3">
              <AppStoreBadge testid="footer-appstore-badge" />
              <GooglePlayBadge testid="footer-googleplay-badge" />
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-center justify-between gap-3 border-t border-[#2C2E29] py-8 text-xs text-[#8E9189] md:flex-row">
          <span>© {year} Waidbook. Alle rechten voorbehouden.</span>
          <span>Waidmannsheil.</span>
        </div>
      </div>
    </footer>
  );
}
